import Link from 'next/link';

import { NavListItemProps } from '@/types/navigation';
import { equals } from '@/utils/common';

import { ListCollapseWrapper } from './ListCollapseWrapper';
import s from './style.module.scss';

export function NavListItem({ itemType, hasNested, children, itemLink }: NavListItemProps) {
  if (hasNested)
    return (
      <ListCollapseWrapper itemLink={itemLink} itemType={itemType}>
        {children}
      </ListCollapseWrapper>
    );

  if (equals(itemType, 'TOC')) return <div className={s.anchor}>{children}</div>;

  return (
    <Link className={s.links_wrapper} href={itemLink}>
      {children}
    </Link>
  );
}
